module.exports = __webpack_public_path__ + "img/bag@2x.31833760.png";